import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit';
import serviceEndpoints from '../../../config/serviceEndpoints';
import proposalGateway from '../../../config/service';
import { getQueryParams } from '../../../utils';

export const resetMsg = createAction('resetMsg');

// Create a new template
export const postTemplate = createAsyncThunk('add-template', async (data, { rejectWithValue }) => {
    const headers = {
        'Content-Type': 'multipart/form-data',
    };
    const body = data;
    try {
        const response = await proposalGateway.post(serviceEndpoints.template, body, { headers });
        const { success, message } = response.data;
        if (success) {
            return response?.data;
        }

        return rejectWithValue(message);
    } catch (error) {
        return error.message;
    }
});

// List All Template
export const getTemplate = createAsyncThunk('list-template', async (data, { rejectWithValue }) => {
    try {
        const response = await proposalGateway.get(`${serviceEndpoints.template}?${getQueryParams(data)}`);
        const { success, message } = response.data;
        if (success) {
            return response?.data;
        }
        return rejectWithValue(message);
    } catch (error) {
        return error.message;
    }
});

// List All Template
export const getTemplateId = createAsyncThunk('get-templateId', async (id, { rejectWithValue }) => {
    try {
        const response = await proposalGateway.get(`${serviceEndpoints.template}/${id}`);
        const { success, message } = response.data;
        if (success) {
            return response?.data;
        }
        return rejectWithValue(message);
    } catch (error) {
        return error.message;
    }
});

// Update a new Template
export const updateTemplate = createAsyncThunk('update-template', async (data, { rejectWithValue }) => {
    const headers = {
        'Content-Type': 'multipart/form-data',
    };
    const body = data;

    try {
        const response = await proposalGateway.put(`${serviceEndpoints.template}/${body.id}`, data.formData, {
            headers,
        });
        if (response.status < 200 || response.status >= 300) {
            return rejectWithValue(response.data);
        }
        return response.data;
    } catch (error) {
        if ((error.response && error.response.status === 401) || error.response.status === 400) {
            return rejectWithValue(error.response.data);
        }
    }
});

// Delete Template
export const deleteTemplate = createAsyncThunk('delete-template', async (data, { rejectWithValue }) => {
    try {
        const response = await proposalGateway.delete(`${serviceEndpoints.template}/${data.id}`);
        if (response.status < 200 || response.status >= 300) {
            return rejectWithValue(response.data);
        }
        return response.data;
    } catch (error) {
        if ((error.response && error.response.status === 401) || error.response.status === 400) {
            return rejectWithValue(error.response.data);
        }
    }
});

export const setDefaultTemplate = createAsyncThunk('set-default-template', async (data, { rejectWithValue }) => {
    try {
        const response = await proposalGateway.put(
            `${serviceEndpoints.template}/${data}${serviceEndpoints.setDefault}`
        );
        if (response.status < 200 || response.status >= 300) {
            return rejectWithValue(response.data);
        }
        return response.data;
    } catch (error) {
        if ((error.response && error.response.status === 401) || error.response.status === 400) {
            return rejectWithValue(error.response.data);
        }
    }
});

const slice = createSlice({
    name: 'employee',
    initialState: {
        errorMessage: '',
        successMessage: '',
        templateData: {},
        singleTemplateData: {},
        isLoading: false,
        isTempLoading: false,
        templateIdData: {},
    },

    extraReducers: (builder) => {
        builder
            .addCase(getTemplate.pending, (state) => {
                state.isTempLoading = true;
                state.errorMessage = '';
                state.successMessage = '';
                state.templateData = [];
            })
            .addCase(getTemplate.rejected, (state, { payload }) => {
                state.isTempLoading = false;
                state.errorMessage = payload.message;
                state.successMessage = '';
                state.templateData = [];
            })
            .addCase(getTemplate.fulfilled, (state, { payload }) => {
                state.isTempLoading = false;
                state.errorMessage = '';
                state.templateData = payload || null;
            })

            .addCase(getTemplateId.pending, (state) => {
                state.isTempLoading = true;
                state.errorMessage = '';
                state.successMessage = '';
                state.templateIdData = {};
            })
            .addCase(getTemplateId.rejected, (state, { payload }) => {
                state.isTempLoading = false;
                state.errorMessage = payload.message;
                state.successMessage = '';
                state.templateIdData = {};
            })
            .addCase(getTemplateId.fulfilled, (state, { payload }) => {
                state.isTempLoading = false;
                state.errorMessage = '';
                state.templateIdData = payload || null;
            })

            .addCase(postTemplate.pending, (state) => {
                state.isLoading = true;
                state.errorMessage = '';
                state.successMessage = '';
            })
            .addCase(postTemplate.rejected, (state, { payload }) => {
                state.isLoading = false;
                state.errorMessage = payload.message;
                state.successMessage = '';
            })
            .addCase(postTemplate.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.errorMessage = '';
                state.successMessage = payload.message;
            })
            .addCase(updateTemplate.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateTemplate.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.successMessage = payload?.message;
            })
            .addCase(updateTemplate.rejected, (state, { payload }) => {
                state.singleTemplateData = {};
                state.isLoading = false;
                state.errorMessage = payload?.message;
            })
            .addCase(deleteTemplate.pending, (state) => {
                state.isLoading = true;
                state.errorMessage = '';
                state.successMessage = '';
            })
            .addCase(deleteTemplate.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.successMessage = payload.message;
            })
            .addCase(deleteTemplate.rejected, (state, { payload }) => {
                state.singleTemplateData = {};
                state.isLoading = false;
                state.errorMessage = payload.message;
            })
            .addCase(setDefaultTemplate.pending, (state) => {
                state.isLoading = true;
                state.errorMessage = '';
                state.successMessage = '';
            })
            .addCase(setDefaultTemplate.rejected, (state, { payload }) => {
                state.isLoading = false;
                state.errorMessage = payload.message;
                state.successMessage = '';
            })
            .addCase(setDefaultTemplate.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.errorMessage = '';
                state.successMessage = payload.message;
            })
            .addCase('resetMsg', (state) => {
                state.errorMessage = '';
                state.successMessage = '';
            });
    },
});

export default slice.reducer;
